import { HttpParams } from '@angular/common/http';
import { Component, forwardRef, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { USER_ME_STATISTICS_V2 } from '../../common/endpoints';
import { StatisticItem } from '../../model';
import { HttpService } from '../../service/http.service';

@Component({
    selector: 'issue-counter',
    template: require('./issue-counter.component.html'),
    styles: [`
        .badge-failure {
            background-color: #df2316;
            color: #ffffff; 
        }
        .badge-major-anomaly {
            background-color: #FFA726;
            color: #ffffff; 
        }
        .badge-minor-anomaly {
            background-color: #f2d229;
            color: #000000;
        }
        `]
})
export class IssueCounterComponent implements OnInit, OnDestroy {

    minorAnomalyCounter: CounterItem;
    majorAnomalyCounter: CounterItem;
    failureCounter: CounterItem;

    private intervalId: any;
    private ISSUE_COUNT_REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes

    constructor(
        @Inject(forwardRef(() => NgZone)) private zone: NgZone,
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }


    ngOnInit() {
        this.updateIssueCount();
        this.zone.runOutsideAngular(() => this.intervalId = setInterval(() => this.updateIssueCount(), this.ISSUE_COUNT_REFRESH_INTERVAL));
    }

    protected updateIssueCount(): void {
        const params = new HttpParams().set('resource', 'event').set('aggregation', 'COUNT').set('activationType', 'ACTIVE');
        Promise.all([
            firstValueFrom(this.httpService.get<StatisticItem[]>(USER_ME_STATISTICS_V2, params.set('eventSeverity', 'eq;2'))),
            firstValueFrom(this.httpService.get<StatisticItem[]>(USER_ME_STATISTICS_V2, params.set('eventSeverity', 'eq;3'))),
            firstValueFrom(this.httpService.get<StatisticItem[]>(USER_ME_STATISTICS_V2, params.set('eventSeverity', 'eq;4')))
        ]).then(results => {
            this.zone.run(() => {
                this.minorAnomalyCounter = this.getCounterItem(results[0][0]);
                this.majorAnomalyCounter = this.getCounterItem(results[1][0]);
                this.failureCounter = this.getCounterItem(results[2][0]);
            })
        });
    }

    private getCounterItem(item: StatisticItem): CounterItem {
        if (!item || isNaN(item.value as any)) {
            return new CounterItem(0);
        }
        return new CounterItem(item.value as number);
    }

    ngOnDestroy(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
}

class CounterItem {
    counter: number;
    label: string;
    capReached: boolean;

    constructor(counter: number) {
        this.counter = counter;
        this.capReached = counter >= 100;
        this.label = this.capReached ? '99+' : `${counter}`;
    }
}